import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'
import type {
  PlayerProgress,
  ProgressRange,
  ProgressSport,
  StatsRole,
} from '../../features/profile/stats/types'

export interface GetPlayerProgressArgs {
  playerId: string
  sportId?: string
  /** A specific generic sport; sent with `sportId` (its base Generic id). */
  genericSportId?: string
  role?: StatsRole
  range: ProgressRange
  timezone: string
}

export const getPlayerProgressSports = async (
  playerId: string
): Promise<ProgressSport[]> => {
  const response = await req(
    ENDPOINTS.PLAYERS.GET_PLAYER_PROGRESS_SPORTS(playerId)
  )
  return Array.isArray(response?.data) ? response.data : []
}

/**
 * `goalie` and `generic_sport_id` are only meaningful alongside a sport, so
 * they are sent only when `sportId` is set (All Sports omits the keys
 * entirely). `generic_sport_id` narrows the base Generic sport to one generic
 * sport; it is never paired with a regular sport id (the API returns 422).
 */
export const getPlayerProgress = async ({
  playerId,
  sportId,
  genericSportId,
  role,
  range,
  timezone,
}: GetPlayerProgressArgs): Promise<PlayerProgress> => {
  const response = await req(ENDPOINTS.PLAYERS.GET_PLAYER_PROGRESS(playerId), {
    query: {
      ...(sportId
        ? {
            sport_id: sportId,
            ...(genericSportId ? { generic_sport_id: genericSportId } : {}),
            goalie: role === 'goalie' ? 1 : 0,
          }
        : {}),
      range,
      timezone,
    },
  })
  if (!response?.data) {
    throw new Error('Invalid progress response')
  }
  return response.data
}
